<template>
    <div class="select-window" @keydown.esc="escapeHandler">
        <input type="text" v-model="textFilter" v-on:input="filterChangeHandler"
               @focus="onFocus"
               :placeholder="placeholderText"
               class="select-window__filter-input">
        <div class="select-window__result" v-if="items && items.length > 0 && showItems">
            <div class="select-window__items">
                <div class="select-window__item"
                     v-for="item in items" :key="item.id"
                     v-on:click="selectHandler(item)">
                    <div class="select-window__item-title">{{item.fonds}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="stylus">
    .select-window__filter-input
        width 100%
        padding .2em $gutter
        font-size 1.1em

    .select-window__result
        position relative

    .select-window__items {
        z-index 100
        max-height: 60vh;
        overflow: auto;
        border 1px solid $color-border
        border-top none
        position absolute
        top 0
        left 0
        right 0
        background-color #fff
    }

    .select-window__item
        padding.5em 15px;
        cursor pointer;
        border 1px solid #ccc;
        line-height 1.1em;
        position relative;
        border-top none
        &:hover
            background-color $color-grey-background

    .select-window__item-title
        font-size: 1em

</style>
<script>
import _ from 'lodash';

export default {
    name: "SelectWindow",
    props: {
        searchText: null,
        placeholderText: null,
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            textFilter: '',
            selectedItem: null,
            showItems: true
        }
    },
    watch: {
      searchText(text) {
          this.textFilter = text;
          this.selectedItem = null;
          //this.filterChangeHandler();
      }
    },
    methods: {
        itemClass(item) {
            return {
                'select-window__item--active': item === this.selectedItem
            }
        },
        filterChangeHandler() {
            this.showItems = true;
            this.$emit('filterchange', this.textFilter);
        },
        selectHandler(item) {
            this.selectedItem = item;
            this.textFilter = item.fonds;
            this.$emit('select', item);
        },
        getNumberOfRelations(item) {
            const relations = item.outgoing;
            const relevantRelations = _.filter(relations, relation => this.relationTypes.indexOf(relation.type) !== -1);
            return relevantRelations.length;
        },
        escapeHandler() {
            this.showItems = false;
        },
        onFocus() {
            this.$emit('filterchange', '');
        }
    }
}
</script>
